// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__DANkE","fullWidth":"styles_fullWidth__684CB"};